import { HttpContextToken } from '@angular/common/http';

export const TOKEN_REQUIRED = new HttpContextToken(() => true);
export const USER_CREADENTIALS_STORAGE_KEY = 'user-credentials';
export const SKIP_AUTH_HEADER = 'X-Skip-Authorization';
